import { type SanitizedResult } from '@amzn/amp-gql'
import { imageFieldsFrag } from './imageFieldsFrag'
import { gql } from './gql'

// language=GraphQL
export const advertisementFieldsFrag = gql(
    `
        fragment advertisementFields on Advertisement @_unmask {
            __typename
            id
            name
            url
            image {
                ...imageFields
            }
            playbackInformation {
                audioUrl
            }
        }
    `,
    [imageFieldsFrag]
)

// Not a schema `PlayableEntity`: the queue plays an ad off its audio url, so it has no uri or playParams.
export type AdvertisementFields = SanitizedResult<typeof advertisementFieldsFrag> & {
    readonly uri?: undefined
    readonly playParams?: undefined
}
